import React from "react";
import TableComplete from "../Tables/TableComplete";
import { Circle } from "../Animation";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import { H3, Label } from "../Text";
import { Request } from "../../hooks/Request";
import { Button } from "../Buttons";
import FormDefault from "../Forms/FormDefault";
import { toast } from "react-toastify";
import { requestAuth } from "../services/RequestService";
import config from "../../config.json";

const InputListAdvances = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  //   function handleForm(item) {
  //     openDialog(
  //       <>
  //         {loadDocument && (
  //           <div className="min-h-[380px]">
  //             <FormAddDocument
  //               data={document}
  //               item={item}
  //               reload={call}
  //               field={field}
  //               onClose={dialogClose}
  //               callDocument={callDocument}
  //             />
  //           </div>
  //         )}
  //       </>
  //     );
  //   }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  function handleAdd() {
    openDialog(
      <FormAddAdvance field={field} onClose={dialogClose} reload={call} />
    );
  }

  return (
    <div>
      <Label htmlFor={field.name} className={`${field.className} my-0 mt-4`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="flex justify-between items-center mb-2">
        <H3 className="font-semibold">Lista de anticipos</H3>
        <Button onClick={handleAdd} className="px-2 py-1">
          Adicionar <i className="fa-solid fa-plus"></i>
        </Button>
      </div>
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Tipo",
              },
              {
                name: "description",
                label: "Monto",
              },
              {
                name: "description5",
                label: "Cuenta Bancaria",
              },
              {
                name: "description3",
                label: "Fecha",
              },
              {
                name: "description4",
                label: "Nro de comprobante",
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                  //   {
                  //     label: "Editar",
                  //     icon: "fas  fa-edit",
                  //     action: handleForm,
                  //     color: "text-[#1d4ed8]",
                  //   },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddAdvance = ({ field, item, onClose, reload }) => {
  async function onSubmit(values, res) {
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      {
        ...values,
        label: `${values?.labelObject?.description} ${values?.labelObject?.code}`,
        description5: `${values.description2Object.name} ${values.description2Object.nroCuentaBancaria}`,
        refVoucherEgressId: res.id,
      }
    )
      .then(() => {
        reload();
        onClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }
  async function onSubmitVoucher(values) {
    const body = {
      type: 2,
      exchangeRate: 6.97,
      voucherDate: values.description3 ?? "",
      coin: "BOB",
      checkNum: values.description4 ?? "",
      canceledTo: values.description3 ?? "",
      gloss: `${values?.label} - ${field?.code}`,
      bankId: values.description2Object.id,
      items: [
        {
          debitBs: 0,
          debitSus: 0,
          assetBs: values.description,
          assetSus: Number(values.description) * 6.97,
          gloss: `${values?.label} - ${field?.code}`,
          // accountId: 157,
          accountId: values.label,
          carpeta: field?.code,
        },
        {
          debitBs: values.description,
          debitSus: Number(values.description) * 6.97,
          assetBs: 0,
          assetSus: 0,
          gloss: `${values?.label} - ${field?.code}`,
          accountId: values.description2,
          carpeta: field?.code,
        },
      ],
    };
    await requestAuth("post", `${config.requestContaURL}/api/Voucher`, body)
      .then(async (res) => {
        await onSubmit(values, res.data);
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  return (
    <>
      <FormDefault
        tittle="Adicionar"
        fields={[
          // {
          //   label: "Tipo",
          //   name: "label",
          //   typeInput: "selectNewOption",
          //   urlApi: field.urlApi,
          //   value: "name",
          //   labelOption: "name",
          // },
          {
            label: "Cuenta",
            name: "label",
            typeInput: "selectGet",
            urlApi: `${config.requestContaURL}/api/Account/Filter?isMotion=true`,
            value: "id",
            labelOption: "description",
          },
          {
            label: "Monto",
            name: "description",
            typeInput: "number",
            type: "number",
          },
          {
            label: "Cuenta Bancaria",
            name: "description2",
            typeInput: "selectGet",
            urlApi: `${config.requestContaURL}/api/Bank`,
            // urlApi: "/Dropdown/CuentasBancariasTrade/options",
            // value: "name",
            value: "accountId",
            labelOption: "name",
          },
          {
            label: "Fecha",
            name: "description3",
            type: "date",
          },
          {
            label: "Nro de comprobante",
            name: "description4",
          },
        ]}
        initialValues={{}}
        validationSchema={null}
        onSubmit={onSubmitVoucher}
        buttonName="Registrar"
      />
      <br />
    </>
  );
};

export default InputListAdvances;
